import { Moment } from 'moment';

export class ProdutoIncentivadoVO {

  id: number;
  idFaturamentoProduto: number;
  portaria: string;
  dataDou: Moment;
  ncm: string;
  tecnac: boolean;
  nome: string;
  houveFaturamento: boolean;
  declaracao: boolean;
  houveFaturamentoAcima: boolean;
  trocouPpbPorPdi: boolean;
  upd: boolean;
  faturamentoAntigo: boolean;
  trimestral: boolean;
  retificacao: boolean;

  constructor(init?: Partial<ProdutoIncentivadoVO>) {
    Object.assign(this, init);
  }

}
